import {
  exportConnProductExcel,
  exportStoreScanRecordByUpdateTime,
  exportStoreScanRecord
} from "@/graphql/Export.gql";
export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    async exportConnProductExcel({ commit, state, rootState }: any, data: any) {
      let res = await rootState.gql.mutate({
        mutation: exportConnProductExcel,
        variables: data
      });
    },
    async exportStoreScanRecord({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: exportStoreScanRecord,
        variables: data
      });
      return res;
    },

    async exportStoreScanRecordByUpdateTime({ rootState }, params) {
      await rootState.gql.query({
        query: exportStoreScanRecordByUpdateTime,
        variables: params
      });
    }
  },
  mutations: {}
};
